export const DAY_IN_SECONDS = 86400;
